module.exports = __webpack_public_path__ + "img/mail-icon.9fd4588a.svg";